export const UPDATE_CREPORTS_PROP = 'UPDATE_CREPORTS_PROP';
export const SENDING_REPORT_SUGG = 'SENDING_REPORT_SUGG';
export const SENT_REPORT_SUGG = 'SENT_REPORT_SUGG';
export const GET_CONTRACTING_DIFF_REPORT = 'GET_CONTRACTING_DIFF_REPORT';
export const CLEAR_STORE = '[contracting-report]CLEAR_STORE';



// WEBPACK FOOTER //
// ./src/app/stores/contracting-reports/constants.js